import Header from './components/Header';
import Home from './components/Home';
import Expertise from './components/Expertise';
import Projects from './components/Projects';
import ProfessionalExperience from './components/ProfessionalExperience';
import Contact from './components/Contact';
// import Footer from './components/Footer';
import './App.css'; // You can style your page here
import React, { useEffect } from 'react';

function App() {
  useEffect(() => {
    const resizeSections = () => {
      const sections = document.querySelectorAll('.full-height');
      sections.forEach((section) => {
        section.style.height = `${window.innerHeight}px`;
      });
    };

    resizeSections(); // Initial resize
    window.addEventListener('resize', resizeSections); // Update on window resize

    return () => {
      window.removeEventListener('resize', resizeSections); // Clean up event listener
    };
  }, []);

  return (
    <div>
      <Header />
      <Home />
      <Expertise />
      <Projects />
      <ProfessionalExperience />
      <Contact />
      {/* <Footer /> */}
    </div>
  );
}

export default App;
